module.exports = __webpack_public_path__ + "static/media/heroku.5df1246b.svg";